export enum TaskPropertyEnum {
  actualArrival,
  actualDeparture,
}
